export default __webpack_public_path__ + "static/media/cladding9.9dbab9d2.jpeg";